module.exports = __webpack_public_path__ + "static/img/s8.f71ce47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/s8.png
// module id = nlku
// module chunks = 0